import { render, staticRenderFns } from "./SwiftMessageOrderCancelModal.vue?vue&type=template&id=22aa0d39"
import script from "./SwiftMessageOrderCancelModal.vue?vue&type=script&lang=js"
export * from "./SwiftMessageOrderCancelModal.vue?vue&type=script&lang=js"
import style0 from "./SwiftMessageOrderCancelModal.vue?vue&type=style&index=0&id=22aa0d39&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports